import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { ClearpayApi } from "../api/ClearpayApi";
import ClearpayLogo from "../assets/images/clearpay-full.svg?react";
import Config from "../Config";
import { useCurrentLocation } from "../contexts/LocationContext";

import "../assets/scss/components/_clearpay.scss";
import { useCartStore } from "../stores/CartStore";

export const Clearpay = () => {
	const { totals } = useCartStore(({ totals }) => {
		return { totals };
	});

	const location = useCurrentLocation();

	const [error, setError] = useState("");
	const [clearpayCheckout, setClearpayCheckout] = useState(false);

	useEffect(() => {
		const urlParams = new URLSearchParams(location?.search || "");
		const status = urlParams.get("status") || "";
		if (status === "CANCELLED")
			setError("You have cancelled your Clearpay payment, please try another payment method or try again.");
		if (status === "FAILED")
			setError("Your Clearpay payment has failed, please try another payment method or try again.");
	}, [location?.search]);

	const clearpayInit = async () => {
		const res = await ClearpayApi.createCheckout();

		if (!res?.payment?.result) {
			setError("Something went wrong on our end, please try again later or proceed to purchase with your card.");
			return;
		}

		const info = res?.payment?.result;
		if (info?.errors.length > 0) {
			//we have an error
			setError(res.errors.message);
			return;
		}

		setClearpayCheckout(true);
		window.location.href = info.redirect_url;
	};

	return (
		totals.grandTotal &&
		totals.grandTotal > 0 &&
		Config.paymentMethodsEnabled.clearpayEnabled === true && (
			<div id="clearpay-widget-container" className="clearpay-widget-container payments-container">
				{error && <div className="alert error">{error}</div>}

				<button className="create-checkout btn" onClick={clearpayInit}>
					Pay With
					<div className="icon">
						<ClearpayLogo style={{ "--fa-width": "100px" }} />
					</div>
				</button>
				<span className="clearpay-terms">
					Instant approval decision - 4 interest-free payments of {Config.currency}
					{parseFloat(totals.grandTotal / 4).toFixed(2)}
				</span>
				{clearpayCheckout && (
					<div className="clearpay-checkout-modal">
						<ClearpayLogo className="clearpay-logo" alt="Clearpay Logo" />
						<p>
							Your Clearpay checkout should open in a couple of seconds, to continue with your purchase
							using Clearpay proceed with the steps there. To cancel and pay by card instead click the
							close button below.
						</p>
						<div className="btn" onClick={clearpayInit}>
							Didn't open? Click here to open Clearpay checkout
						</div>
						<div
							className="btn close-button"
							onClick={() => {
								setClearpayCheckout(false);
							}}
						>
							Close Clearpay Checkout
						</div>
					</div>
				)}
			</div>
		)
	);
};

export default Clearpay;
